import appConfig from "./appConfig";

const BULK_SUBSCRIPTIONS_BASE_PATH = "/bulk-subscriptions";

function appPath(path?: string, windowLocation = location): string {
    return withoutQuery(path) + windowLocation.search;
}

function withIframePrefix(path: string, windowLocation = location): string {
    if (isIframePath(windowLocation)) {
        return withoutQuery(`/iframe${ path }`) + windowLocation.search;
    }

    return appPath(path, windowLocation);
}

function isIframePath(windowLocation = location): boolean {
    const BASE_PATH = appConfig().basePath;

    const path = windowLocation.pathname;

    const relativePath = BASE_PATH ? path.substr(BASE_PATH.length) : path;

    return relativePath.startsWith("/iframe");
}

function withoutQuery(path?: string): string {
    const BASE_PATH = appConfig().basePath;

    if (!path) {
        return BASE_PATH;
    }

    const pathWithoutQuery = getPathFromUrl(path);

    if (pathWithoutQuery.startsWith(BASE_PATH) || pathWithoutQuery.startsWith(BULK_SUBSCRIPTIONS_BASE_PATH)) {
        return pathWithoutQuery;
    }

    return `${ BASE_PATH }${ pathWithoutQuery }`;
}

function getPathFromUrl(url = ""): string {
    return url.split("?")[0];
}

appPath.isIframePath = isIframePath;
appPath.withIframePrefix = withIframePrefix;
appPath.withoutQuery = withoutQuery;

export default appPath;
